export const workExperiences = [
  {
    company: "Paymentus",
    title: "Full Stack Engineer",
    duration: "Oct 2024 - Present",
    description:
      "Engineered custom solutions on a large-scale payment platform, contributing to new feature development and system improvements across multiple projects.",
    technologies: [
      "Java",
      "JavaScript",
      "Node.js",
      "ReactJS",
      "Apache FreeMarker",
      "HTML & CSS",
      "Kubernetes",
      "Tomcat",
      "OracleDB",
      "Snowflake",
    ],
    companyUrl: "https://www.paymentus.com/",
  },
  {
    company: "CIBC Capital Markets",
    title: "Consultant, Application Development",
    duration: "Mar - Sept 2024",
    description:
      "Supported and maintained infrastructure, delivering reliable messaging platforms for multiple projects within the Capital Markets Engineering.",
    technologies: [
      "Java",
      "Openshift",
      "Helm Charts",
      "Kubernetes",
      "Microsoft Azure",
      "Git",
      "Solace",
    ],
    companyUrl: "https://cibccm.com/en/",
  },
  {
    company: "UKG",
    title: "Software Engineer II",
    duration: "Jan - Aug 2023",
    description:
      "Improved scalability and reliability of microservices architecture to support high-throughput message delivery across multiple notification channels.",
    technologies: [
      "Java",
      "Spring Boot",
      "Kafka",
      "RabbitMQ",
      "Docker",
      "Git",
      "AWS SES,SQS & SNS",
      "OAuth",
      "REST API",
      "AWS S3",
    ],
    companyUrl: "https://www.ukg.com/",
  },
  {
    company: "UKG",
    title: "Software Engineer I",
    duration: "May 2021 - Dec 2022",
    description:
      "Developed and maintained backend systems, driving enhancements and ensuring stability for enterprise-scale notification services.",
    technologies: [
      "Java",
      "Spring Boot",
      "Kafka",
      "RabbitMQ",
      "Docker",
      "Git",
      "AWS SES,SQS & SNS",
      "OAuth",
      "REST API",
      "AWS S3",
      "OpenAPI",
    ],
    companyUrl: "https://www.ukg.com/",
  },
  {
    company: "Oracle",
    title: "DevOps Engineer Intern",
    duration: "May 2019 - May 2020",
    description:
      "Managed and optimized CI/CD pipelines for Oracle Eloqua, enabling seamless and consistent deployment processes.",
    technologies: [
      "Python",
      "TypeScript",
      "Ruby",
      "Docker",
      "Kubernetes",
      "Oracle Cloud",
      "Jenkins",
      "Teamcity",
      "Sensu",
      "Linux",
      "Windows Hyper-V",
      "Terraform",
    ],
    companyUrl: "https://www.oracle.com/ca-en/",
  },
  {
    company: "Toyota Canada Inc",
    title: "Technical Analyst Intern",
    duration: "Jan 2018 - Apr 2018",
    description:
      "Provided advanced IT support, managing device setup, hardware and asset tracking, and troubleshooting technical issues for internal users.",
    technologies: ["SQL", "Cisco VoIP", "Imaging", "Excel", "Active Directory"],
    companyUrl: "https://www.toyota.ca/toyota/en/",
  },
];

export const programmingLanguages = [
  { name: "Java", proficiency: 85 },
  { name: "Python", proficiency: 75 },
  { name: "TypeScript", proficiency: 10 },
  { name: "HTML & CSS", proficiency: 70 },
  { name: "JavaScript", proficiency: 50 },
  { name: "SQL", proficiency: 70 },
  { name: ".Net", proficiency: 10 },
];

export const frameworksLibraries = [
  { name: "React", proficiency: 40 },
  { name: "Node.js", proficiency: 50 },
  { name: "ExpressJS", proficiency: 20 },
  { name: "Spring Boot", proficiency: 80 },
  { name: "AngularJS", proficiency: 10 },
  { name: "Apache FreeMarker (FTL)", proficiency: 55 },
];

export const toolsTechnologies = [
  { name: "Git", proficiency: 90 },
  { name: "Docker", proficiency: 70 },
  { name: "AWS", proficiency: 65 },
  { name: "MongoDB", proficiency: 60 },
  { name: "REST API", proficiency: 70 },
  { name: "Kafka", proficiency: 60 },
  { name: "RabbitMQ", proficiency: 50 },
  { name: "MySQL", proficiency: 60 },
  { name: "OracleDB", proficiency: 40 },
  { name: "Kubernetes", proficiency: 50 },
  { name: "AWS SES, SQS, SNS", proficiency: 30 },
  { name: "AWS S3", proficiency: 70 },
  { name: "Snowflake", proficiency: 40 },
];

export const heroInfo = {
  fullName: "Philip Zhang",
  title: "Software Engineer",
  description:
    "Hey, I'm a University of Toronto Computer Science grad with a passion for backend development and DevOps. Over the past few years, I've enjoyed working on systems that are fast, reliable, and easy to scale — and I'm always exploring new technologies to bring into my work.",
};

export const sectionHeaders = {
  aboutMe: "About Me",
  workExperiences: "Work Experience",
  certificates: "Certificates",
  programmingLanguages: "Programming Languages",
  frameworksLibraries: "Frameworks & Libraries",
  toolsTechnologies: "Tools & Technologies",
};

export const personalProjects = [
  {
    title: "Angleo",
    pic: "icons/javascript.png",
    text: "A mobile application built using React Native to bridge the cultural divide between English and French-speaking communities in Quebec. (Built during ConUHacks IV)",
    url: "https://github.com/alvintangz/angleo",
    link: "",
  },
  {
    title: "SenpaiBot (Discord Server Bot)",
    pic: "icons/python.png",
    text: "A Python-based bot using Discord API, designed for our team's Discord server with gaming-friendly features.",
    url: "https://github.com/SnoopySnipe/SenpaiBot",
    link: "",
  },
  {
    title: "Rhythm Rivals",
    pic: "icons/java.png",
    text: "A music rhythm game using GreenFoot UI and Java. Players press keys as colored circles drop, acting as beats. (Built during Hack The Valley I at UTSC)",
    url: "https://github.com/AdityaMatam/RhythmRivals",
    link: "",
  },
  {
    title: "Old Personal Website",
    pic: "icons/html.png",
    text: "A project built using vanilla JS, HTML, and CSS to familiarize myself with these technologies.",
    url: "https://github.com/ImNotMee/ImNotMee.github.io",
    link: "http://ImNotMee.github.io",
  },
];

export const certificates = [
  {
    title: "Building AI Agents and Agentic Workflows",
    issuer: "IBM",
    date: "Jul 2026",
    text: "",
    link: "https://www.coursera.org/account/accomplishments/specialization/certificate/06Q5QP7TXNHY",
  },
  {
    title: "Agentic AI with LangChain and LangGraph",
    issuer: "IBM",
    date: "Jul 2026",
    text: "",
    link: "https://www.coursera.org/account/accomplishments/certificate/8GVJBGI89PLO",
  },
  {
    title: "Fundamentals of Building AI Agents",
    issuer: "IBM",
    date: "May 2026",
    text: "",
    link: "https://www.coursera.org/account/accomplishments/certificate/V11LC3DW9SCB",
  },
  {
    title: "Oracle Certified Associate, Java SE 8 Programmer",
    issuer: "Oracle",
    date: "Sep 2018",
    text: "",
    link: "https://www.credly.com/badges/6acbeaf9-1fd0-4c80-bf5d-b67028543145",
  },
];

export const academicProjects = [
  {
    title: "ChronoJS",
    pic: "icons/javascript.png",
    text: "A customizable calendar front-end library built using vanilla JavaScript.",
    url: "https://github.com/ImNotMee/ChronoJS",
    link: "https://imnotmee.github.io/ChronoJS/index.html",
  },
  {
    title: "Health Tracker",
    pic: "icons/javascript.png",
    text: "An app for tracking physical, medical, and mental health data, with a COVID tracker for nearby locations. Built using React.js and Node.js.",
    url: "https://github.com/ImNotMee/HealthTracker",
    link: "https://csc309-2020-team27.herokuapp.com/",
  },
  {
    title: "TEQ Reporting App",
    pic: "icons/python.png",
    text: "A Python app for TEQ to centralize data from agencies and generate reports and summaries.",
    url: "https://github.com/ImNotMee/TEQ-App",
    link: "",
  },
  {
    title: "BigBoiBank$",
    pic: "icons/java.png",
    text: "A Java-based Android app simulating a real bank, designed using OOP principles.",
    url: "https://github.com/ImNotMee/BigBoiBank",
    link: "",
  },
  {
    title: "A Simple Search Engine",
    pic: "icons/c.png",
    text: "A C program to search .txt files for a keyword and output the number of occurrences in each file using forking and piping.",
    url: "",
    link: "",
  },
];

export const profileInfo = {
  name: "Philip",
  alumniTag: "An UofT Alumni",
  copyrightYear: "2026",
};

export const SOCIAL_LINKS = [
  {
    name: "Instagram",
    url: "https://www.instagram.com/_philzpng_/",
    icon: "icons/instagram.png",
  },
  {
    name: "LinkedIn",
    url: "https://www.linkedin.com/in/philip-z/",
    icon: "icons/linkedin.png",
  },
  {
    name: "GitHub",
    url: "https://github.com/ImNotMee",
    icon: "icons/GitHub.png",
  },
];

export const PAGE_VALUES = {
  ME: "me",
  PROJECTS: "projects",
  PHOTO: "photo",
  CONTACT: "contact",
};

export const NAV_BUTTONS = [
  {
    label: "About Me",
    value: PAGE_VALUES.ME,
  },
  {
    label: "Projects",
    value: PAGE_VALUES.PROJECTS,
  },
  {
    label: "Photos",
    value: PAGE_VALUES.PHOTO,
  },
  {
    label: "Contact me",
    value: PAGE_VALUES.CONTACT,
    onClick: () => {
      window.location = "mailto:philip.zhang@mail.utoronto.ca";
    },
  },
];

export const errorPageContent = {
  errorCode: "404",
  title: "Page Not Found",
  message: "Well, this is awkward… the page you're looking for doesn't exist...",
  suggestion: "Let's teleport you back!",
  homeButtonText: "Go Back Home",
  backButtonText: "Go Back",
};

export const defaultAbout = {
  heroInfo,
  profileInfo,
  sectionHeaders,
  workExperiences,
  certificates,
  skills: {
    programmingLanguages,
    frameworksLibraries,
    toolsTechnologies,
  },
};

export const defaultProjects = {
  personal: personalProjects,
  academic: academicProjects,
};

export const defaultProfile = {
  profileInfo,
  socialLinks: SOCIAL_LINKS,
};
